export default __webpack_public_path__ + "static/media/edit.9be599c7.svg";